"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBPropertySellPositive = function SvgBPropertySellPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M48.281 130.258a2.205 2.205 0 01.033-4.409l8.355-.023-.134-49.969a2.204 2.204 0 012.199-2.21l27.747-.075a2.206 2.206 0 012.21 2.2l.136 49.873 22.045-.056.045.001a2.204 2.204 0 01-.033 4.408l-24.25.07a2.204 2.204 0 01-2.21-2.2l-.136-49.873-23.339.063.135 49.969a2.204 2.204 0 01-2.2 2.21l-10.559.029-.044-.008z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M121.34 129.96a2.204 2.204 0 01-2.165-2.198l-.136-52.019a2.204 2.204 0 012.2-2.21l18.37-.054a.257.257 0 00.184-.438L70.867 4.478a2.204 2.204 0 113.112-3.12l68.897 68.533a4.665 4.665 0 01-3.277 7.974l-16.167.042.124 47.64 11.757-.03a2.205 2.205 0 11.012 4.408l-13.962.036h-.022z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M5.527 78.222a4.666 4.666 0 01-3.226-7.956L63.93 8.311a2.206 2.206 0 113.127 3.11L5.428 73.379a.228.228 0 00-.056.278.235.235 0 00.24.159l21.817-.06a2.205 2.205 0 11.011 4.409l-21.817.06-.096-.002z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M27.596 139.949a2.204 2.204 0 01-2.166-2.198l-.031-12.94a2.205 2.205 0 114.409-.012l.03 12.977a2.204 2.204 0 01-2.198 2.21l-.044-.037zM27.489 99.782a2.204 2.204 0 01-2.166-2.198l-.062-21.31a2.204 2.204 0 012.2-2.21h.043c1.2.021 2.163.998 2.166 2.199l.054 21.347a2.204 2.204 0 01-2.192 2.21l-.043-.038z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M27.399 125.999a9.485 9.485 0 01-6.364-2.522c-.412-.382-1.075-1.135-1.197-1.284a2.204 2.204 0 113.313-2.882c.26.299.72.8.901.979a5.356 5.356 0 007.01.041 3.776 3.776 0 001.313-2.82c-.01-2.433-2.511-3.902-4.984-4.1a12.093 12.093 0 01-3.2-.673c-3.59-1.437-5.8-4.422-5.838-7.795a8.148 8.148 0 012.76-6.154 9.595 9.595 0 016.414-2.43l.073.001a9.602 9.602 0 017.53 3.872l.115.149a2.205 2.205 0 01-3.514 2.664l-.115-.149a5.143 5.143 0 00-7.546-.866 3.784 3.784 0 00-1.306 2.814c.003 2.366 2.35 3.487 3.064 3.771.621.206 1.266.33 1.92.372 5.224.414 9.02 3.978 9.036 8.468a8.155 8.155 0 01-2.766 6.117 9.551 9.551 0 01-6.413 2.423l-.206.004z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M10.205 140.71a2.204 2.204 0 01-2.166-2.198l-.095-45.104a2.204 2.204 0 01.637-1.56l17.33-17.444a2.206 2.206 0 013.128 3.111L12.337 94.308l.112 41.989 30.386-.08-.12-41.966-6.428-6.395a2.204 2.204 0 013.104-3.128l7.078 7.046c.419.408.653.97.65 1.554l.123 45.09a2.204 2.204 0 01-2.199 2.21l-34.794.083h-.044z",
    fill: "#285"
  })));
};

var _default = SvgBPropertySellPositive;
exports["default"] = _default;